/**
 * Aksiyon bazlı sayfa izni hook'u.
 *
 * Kullanım:
 *   const { canRead, canEdit, canAdd, canDelete } = usePermission();        // aktif sayfa
 *   const { canEdit } = usePermission('/it/users/create');                  // belirli sayfa
 *
 * Buton örneği: <Button disabled={!canEdit}>Kaydet</Button>
 */
import { useLocation } from 'react-router-dom';

import { useAuth } from '../components/common/security/AuthContext';
import { canActOnPage } from '../utils/permissions';
import type { PermAction } from '../utils/permissions';

export interface PagePermissionFlags {
  canRead: boolean;
  canEdit: boolean;
  canAdd: boolean;
  canDelete: boolean;
  /** Verilen aksiyon için kontrol (dinamik kullanım) */
  can: (action: PermAction) => boolean;
  role: string | null;
}

export const usePermission = (path?: string): PagePermissionFlags => {
  const { page_permissions, permitted_pages, role } = useAuth();
  const location = useLocation();
  const target = path ?? location.pathname;

  const can = (action: PermAction) =>
    canActOnPage(page_permissions, permitted_pages, target, action);

  return {
    canRead: can('read'),
    canEdit: can('edit'),
    canAdd: can('add'),
    canDelete: can('delete'),
    can,
    role,
  };
};
